(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation"]) return;
  try {
    
$(document).ready(function(e) {
  $("li.cc-nav-item").click(function(event) {
    $("#cc-open-nav").toggleClass("main-nav-open main-nav-close");
    event.stopPropagation();
  });
    $(document).click(function(event) {
    if (!$(event.target).hasClass('siteNavigation')) {
      $("#cc-open-nav").removeClass("main-nav-open main-nav-close");
    }
  });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test"]) return;
  try {
    
$(document).ready(function(e) {
  $("li.cc-nav-item").click(function(event) {
    $("#cc-open-nav").toggleClass("main-nav-open main-nav-close");
    event.stopPropagation();
  });
    $(document).click(function(event) {
    if (!$(event.target).hasClass('siteNavigation')) {
      $("#cc-open-nav").removeClass("main-nav-open main-nav-close");
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
